import { render, staticRenderFns } from "./LimpezaConsultor.vue?vue&type=template&id=68843001"
import script from "./LimpezaConsultor.vue?vue&type=script&lang=ts"
export * from "./LimpezaConsultor.vue?vue&type=script&lang=ts"
import style0 from "./LimpezaConsultor.vue?vue&type=style&index=0&id=68843001&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports